import Tools from './../components/tools';
import gsap from 'gsap';
import { tns } from './../../../node_modules/tiny-slider/src/tiny-slider';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default class Page {
  constructor() {
    // Page
    gsap.registerPlugin(ScrollTrigger);

    this.maxHeight = 0;

    this.hoversArchive();
    this.playerArchive();
    this.animArchive();
    this.headerMethodologie();
    this.methodologie();
    this.contact();
    this.sliderVideo();

    // Blocks
    this.faq();
    this.sliderTemoignage();
    this.videos();

    this.sliderHeader();

    window.addEventListener('resize', () => {
      this.contact();
    });
  }

  hoversArchive() {
    const items = document.querySelectorAll('.archive section .container .realisations .item');
    if (items.length > 0) {
      items.forEach((item) => {
        item.querySelector('.figure').addEventListener('mouseenter', () => {
          item.querySelector('video').play();
        });

        item.querySelector('.figure').addEventListener('mouseleave', () => {
          item.querySelector('video').pause();
        });
      });
    }
  }

  playerArchive() {
    const items = document.querySelectorAll('.archive section .container .realisations .item');
    if (items.length > 0) {
      items.forEach((item) => {
        item.addEventListener('click', () => {
          document.querySelector('.popin-video').classList.add('visible');
          document.querySelector('.popin-video iframe').src = `${item.querySelector('.figure').dataset.id}?fallback=true`;
        });
      });

      const popin = document.querySelector('.popin-video');
      if (popin) {
        popin.querySelector('.close').addEventListener('click', () => {
          document.querySelector('.popin-video').classList.remove('visible');
          document.querySelector('.popin-video iframe').src = '';
        });
      }
    }
  }

  animArchive() {
    const items = document.querySelectorAll('.page-template-methodologie header .container .three-cols .item img');
    if (items.length > 0) {
      gsap.to(
        items,
        {
          scrollTrigger: {
            trigger: document.querySelector('.page-template-methodologie header .container .three-cols'),
            start: 'top 66%'
          },
          ease: "power4.out",
          duration: 1.35,
          y: 0,
          opacity: 1,
          stagger: 0.1,
        }
      );
    }

    const dash = document.querySelector('.page-template-methodologie section article .container .methodologie .dash');
    if (dash) {
      gsap.to(
        dash,
        {
          scrollTrigger: {
            trigger: document.querySelector('.page-template-methodologie section article .container .methodologie'),
            start: 'top 50%'
          },
          ease: "power4.out",
          duration: 1.35,
          width: '100%',
        }
      );
    }
  }

  headerMethodologie() {
    const items = document.querySelectorAll('.page-template-methodologie header .container .three-cols .item');
    if (items.length > 0) {
      items.forEach((item) => {
        if (item.querySelector('.popin')) {
          item.querySelector('figure').addEventListener('click', () => {
            item.classList.add('open');
          });

          item.querySelector('.popin .close').addEventListener('click', () => {
            item.classList.remove('open');
          });
        }
      });
    }
  }

  methodologie() {
    const items = document.querySelectorAll('.page-template-methodologie section article .container .methodologie .item');
    const methodo = document.querySelector('.page-template-methodologie section article .container .methodologie');

    if (items.length > 0) {
      if (window.innerWidth > 1023) {
        items.forEach((item) => {
          if (item.offsetHeight > this.maxHeight) {
            this.maxHeight = item.offsetHeight;
          }

          item.addEventListener('click', () => {
            const activeElt = document.querySelector('section article .container .methodologie .item.visible');
            if (activeElt) {
              activeElt.classList.remove('visible');
            }
            item.classList.add('visible');

            const nodes = Array.prototype.slice.call(methodo.children);
            this.progressLine(nodes.indexOf(item));
          });
        });

        methodo.style.height = `${this.maxHeight * 2}px`;
        items.forEach((item) => {
          item.style.height = `${this.maxHeight}px`;
        });
      }
    }
  }

  progressLine(progress) {
    const line = document.querySelector('section article .container .methodologie .dash');
    const items = document.querySelectorAll('.page-template-methodologie section article .container .methodologie .item');

    if (line) {
      let value = 0;
      if (progress != 0) {
        if (progress == 4) {
          value = -1000;
        } else {
          value = 100 - ((progress + 4) * (100 / items.length));
        }
      } else {
        value = 100;
      }
      line.style.background = `transparent linear-gradient(90deg, #000000 ${value}%, #FFFFFF 100%) 0% 0% no-repeat`;
    }
  }

  contact() {
    const iframe = document.querySelector('.page-template-contact section article .two-cols .col iframe');
    if (iframe) {
      const width = (window.innerWidth - document.querySelector('section article .container').offsetWidth) / 2;
      const colWidth = document.querySelector('section article iframe').offsetWidth;
      iframe.style.width = `${width + colWidth}px`;
    }
  }

  faq() {
    const elements = document.querySelectorAll('.hep-block-faq__item');
    if (elements.length > 0) {
      elements.forEach((element) => {
        element.querySelector('.hep-block-faq__title').addEventListener('click', (e) => {
          e.preventDefault();
          element.classList.toggle('js-open');

          if (element.classList.contains('js-open')) {
            Tools.zeroToAuto(element.querySelector('.hep-block-faq__wrapper'));
          } else {
            Tools.autoToZero(element.querySelector('.hep-block-faq__wrapper'));
          }
        });
      });
    }
  }

  sliderVideo() {
    const containers = document.querySelectorAll('.hep-block-slider-video');
    if (containers.length > 0) {
      containers.forEach((container) => {
        const slider = container.querySelector('.hep-block-slider-video__slider');
        if(slider) {
          tns({
            container: slider,
            autoWidth: true,
            items: 4,
            slideBy: 'page',
            gutter: 20,
            controls: true,
            nav: false,
            loop: false,
            speed: 850,
            mouseDrag: false,
          });
  
          const popin = document.querySelector('section + aside.popin-video');
          slider.querySelectorAll('.hep-block-slider-video__wrapper').forEach((slide) => {
            slide.addEventListener('mouseenter', () => {
              if (slider.querySelector('.hep-block-slider-video__wrapper.js-active')) {
                slider.querySelector('.hep-block-slider-video__wrapper.js-active').classList.remove('js-active');
              }
              slide.querySelector('.hep-block-slider-video__player').play();
  
              slide.classList.add('js-active');
            });
  
            slide.addEventListener('mouseleave', () => {
              slide.querySelector('.hep-block-slider-video__player').pause();
            });
  
            slide.addEventListener('click', (e) => {
              e.preventDefault();
              popin.classList.add('visible');
              popin.querySelector('iframe').src = `${slide.querySelector('.hep-block-slider-video__container').dataset.id}?fallback=true`;
            });
  
            if (popin) {
              popin.querySelector('.close').addEventListener('click', (e) => {
                e.preventDefault();
                popin.classList.remove('visible');
                popin.querySelector('iframe').src = '';
              });
            }
          });
        }
      });
    }
  }

  sliderTemoignage() {
    const containers = document.querySelectorAll('.hep-block-temoignage');
    if(containers.length > 0) {
      containers.forEach((container) => {
        const slider = container.querySelector('.hep-block-temoignage__slider');
        if(slider) {
          tns({
            container: slider,
            items: 1,
            slideBy: 'page',
            controls: false,
            nav: false,
            loop: false,
            speed: 850,
            gutter: 20,
            mouseDrag: false,
            responsive: {
              1024: {
                controls: true,
                gutter: 100,
              }
            }
          });
  
          const popin = document.querySelector('section + aside.popin-video');
          slider.querySelectorAll('.hep-block-temoignage__wrapper').forEach((slide) => {
            console.log(slide);
            if(slide.querySelector('.hep-block-temoignage__figure') && slide.querySelector('.hep-block-temoignage__container').dataset.id) {
              slide.querySelector('.hep-block-temoignage__figure').addEventListener('click', (e) => {
                e.preventDefault();
                popin.classList.add('visible');
                popin.querySelector('iframe').src = `${slide.querySelector('.hep-block-temoignage__container').dataset.id}?fallback=true`;
              });
            }
  
            if (popin) {
              popin.querySelector('.close').addEventListener('click', (e) => {
                e.preventDefault();
                popin.classList.remove('visible');
                popin.querySelector('iframe').src = '';
              });
            }
          });
        }
      })
    }
  }

  videos() {
    const containers = document.querySelectorAll('.hep-block-videos');
    if(containers.length > 0) {
      containers.forEach((container) => {
        container.querySelectorAll('.hep-block-videos__contentItem').forEach((item) => {
          item.addEventListener('click', (e) => {
            e.preventDefault();
            if(container.querySelector('.hep-block-videos__contentItem.js-active')) {
              container.querySelector('.hep-block-videos__contentItem.js-active').classList.remove('js-active');
            }
            item.classList.add('js-active');

            if(container.querySelector('.hep-block-videos__playerItem.js-active')) {
              container.querySelector('.hep-block-videos__playerItem.js-active').classList.remove('js-active');
            }
            container.querySelector(`.hep-block-videos__player [data-target="${item.dataset.id}"]`).classList.add('js-active');
          });
        });

        const popin = document.querySelector('section + aside.popin-video');
        container.querySelectorAll('.hep-block-videos__playerItem').forEach((elt) => {
          elt.addEventListener('mouseenter', (e) => {
            e.preventDefault();
            elt.querySelector('.hep-block-videos__movie').play();
          });

          elt.addEventListener('mouseleave', (e) => {
            e.preventDefault();
            elt.querySelector('.hep-block-videos__movie').pause();
          });

          elt.addEventListener('click', (e) => {
            e.preventDefault();
            popin.classList.add('visible');
            popin.querySelector('iframe').src = `${elt.dataset.id}?fallback=true`;
          });

          if (popin) {
            popin.querySelector('.close').addEventListener('click', (e) => {
              e.preventDefault();
              popin.classList.remove('visible');
              popin.querySelector('iframe').src = '';
            });
          }
        });
      });
    }
  }

  sliderHeader() {
    const slider = document.querySelector('header .header__slider');
    if(slider) {
      tns({
        container: slider,
        items: 1,
        slideBy: 'page',
        controls: false,
        nav: false,
        loop: true,
        speed: 850,
        gutter: 0,
        mouseDrag: true,
        autoplay: true,
        autoplayTimeout: 6000,
        autoplayButtonOutput: false,
      });
    }
  }
}